import React, { FC } from 'react';
import { Box, Container, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/ReadyForAdventureSection/ReadyForAdventureSection.styles';

const ReadyForAdventureSectionSkeleton: FC = () => {
  return (
    <StyledBox>
      <Container maxWidth="xl" className="RFASContentContainer">
        <Box className="RFASContent">
          {/* Title Skeleton */}
          <Skeleton variant="text" width={350} height={48} />
          
          {/* Description Skeleton */}
          <Box my={2}>
            <Skeleton variant="text" width="90%" height={24} />
            <Skeleton variant="text" width="80%" height={24} />
          </Box>
          
          {/* Button Skeleton */}
          <Skeleton 
            variant="rectangular" 
            width={150} 
            height={40} 
            sx={{ borderRadius: 1 }} 
            className="RFASBtn"
          />
        </Box>
      </Container>
    </StyledBox>
  );
};

export { ReadyForAdventureSectionSkeleton };